export default __webpack_public_path__ + "static/media/ic_logo.98590a21.svg";